import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { WaitLoadingModule } from '../../components/common/waitLoading/waitLoading.module';

import { TranslateModule } from '@ngx-translate/core';

import { configurationComponent } from './configuration.component';
import { FormPlycaModule } from '../../components/forms/formPlyca.module';
import { ButtonModule } from 'primeng-lts/button';
import { DropdownModule } from 'primeng-lts/dropdown';
import { PanelModule } from 'primeng-lts/panel';
import { TooltipModule } from 'primeng-lts/tooltip';
import { MenuModule } from 'primeng-lts/menu';
import { TableModule } from 'primeng-lts/table';

@NgModule({
  declarations: [configurationComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    TableModule,
    TooltipModule,
    FormPlycaModule,
    PanelModule,
    MenuModule,
    ButtonModule,
    DropdownModule,
    TranslateModule,
    WaitLoadingModule
  ]
})
export class ConfigurationModule { }
